/*
 * @Author: Risker-C
 * @Date: 2021-09-13 17:20:52
 * @LastEditTime: 2021-09-13 17:38:12
 * @LastEditors: Risker-C
 * @Description: 
 * @FilePath: \yh-wms\src\views\content\video\view\index.tsx
 */
import React from 'react';
import { PageHeader } from "./PageHeader"
import { DataBox } from "./DataBox"
export function Video() {
  return (
    <>
      <PageHeader />
      <DataBox />
    </>
  );
}


